import { computed } from 'vue';
import { currentLanguage } from '@/utils';
import proposal from './proposal';

// Domains group related keys. Add more domain files as needed (e.g., common, forms, nav).
const domains = { proposal };

function format(str, params) {
  if (!params) {
    return str;
  }

  return Object.keys(params).reduce(
    (acc, key) => acc.replace(new RegExp(`\\{${key}\\}`, 'g'), String(params[key])),
    str,
  );
}

function getFromDomain(path) {
  // path like 'proposal.accepted_title'
  const [domain, key] = path.split('.');

  // returns { en: '...', no: '...' } or undefined
  return domains[domain]?.[key];
}

function pickString(langMap, lang) {
  if (!langMap) {
    return undefined;
  }

  // Desired language first
  if (typeof langMap[lang] === 'string') {
    return langMap[lang];
  }

  // English fallback
  if (typeof langMap.en === 'string') {
    return langMap.en;
  }

  // Any available translation as last resort
  const first = Object.values(langMap).find((v) => typeof v === 'string');

  return first;
}

export function t(key, params) {
  const lang = currentLanguage.value || 'en';
  const langMap = getFromDomain(key);
  const str = pickString(langMap, lang);

  // fall back to key if entirely missing
  return str ? format(str, params) : key;
}

export function useI18n() {
  const rt = computed(() => (k, p) => t(k, p));

  return {
    t: (k, p) => t(k, p),
    rt,
  };
}

export default {
  install(app) {
    // Global property for Options API templates: this.$t('key')
    app.config.globalProperties.$t = (key, params) => t(key, params);

    // Provide for inject/use in setup if desired
    app.provide('t', t);
  },
};
